var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8C18 5.794 19.794 4 22 4C24.206 4 26 5.794 26 8C26 10.206 24.206 12 22 12C19.794 12 18 10.206 18 8ZM16 8C16 11.309 18.691 14 22 14C23.294 14 24.49 13.584 25.471 12.885L28.586 16L30 14.586L26.885 11.471C27.584 10.49 28 9.294 28 8C28 4.691 25.309 2 22 2C18.691 2 16 4.691 16 8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24H21V26H11V24Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 28H19V30H13V28Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8101 18.1418C9.42609 16.8638 7.99609 15.5228 7.99609 12.0008C7.99609 8.28078 10.5501 5.15478 13.9961 4.26378L13.6091 2.30078C9.24609 3.37478 5.99609 7.31078 5.99609 12.0008C5.99609 16.4018 7.99509 18.2688 9.45509 19.6178C10.4671 20.5518 10.9961 21.0828 10.9961 22.0008H12.9961C12.9961 20.1618 11.8851 19.1348 10.8101 18.1418Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.05 16C22.524 16.887 21.845 17.524 21.178 18.143C20.108 19.135 19.001 20.161 19.001 22H21.001C21.001 21.081 21.527 20.55 22.536 19.614C23.297 18.909 24.207 18.058 24.904 16.781L23.05 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentSearch);
export default __webpack_public_path__ + "static/media/agent-search.a100f3aa9ddbeb61a021fdff771d3add.svg";
export { ForwardRef as ReactComponent };